import React from 'react';
import useSessionStorage from './useSessionStorage';
import { useRecoilState } from 'recoil';
import { confirmState } from '../store/Atoms';
import { useNavigate } from 'react-router-dom';

const UseLogInOut = () => {
  const { removeAllStorage } = useSessionStorage('token');
  const [confirm, setConfirm] = useRecoilState(confirmState);
  const navigate = useNavigate();

  const onLogInOut = () => {
    if (!!sessionStorage.getItem('token')) {
      removeAllStorage();
      setConfirm({ ...confirm, text: '로그아웃 했습니다.', submitFunc: () => setConfirm({ ...confirm, text: '' }) });
    } else {
      navigate('/login');
    }
  };
  return { onLogInOut };
};

export default UseLogInOut;
